var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.00024C6.48 2.00024 2 6.48024 2 12.0002C2 17.5202 6.48 22.0002 12 22.0002C17.52 22.0002 22 17.5202 22 12.0002C22 6.48024 17.52 2.00024 12 2.00024ZM4 12.0002C4 7.58024 7.58 4.00024 12 4.00024C13.85 4.00024 15.55 4.63024 16.9 5.69024L5.69 16.9002C4.59177 15.5034 3.99639 13.7771 4 12.0002ZM12 20.0002C10.15 20.0002 8.45 19.3702 7.1 18.3102L18.31 7.10024C19.4082 8.49711 20.0036 10.2234 20 12.0002C20 16.4202 16.42 20.0002 12 20.0002Z",
    fill: "#CF283A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockRed);
export default __webpack_public_path__ + "static/media/block-red.9f4ca370d8d24feadf018f33f488fc05.svg";
export { ForwardRef as ReactComponent };